import { Box, styled } from '@mui/material';
import React, { MouseEventHandler } from 'react';

type DeviceWidth = {
  deviceWidth: { mobile?: string; tablet?: string; desktop: string };
};
interface ResponsiveSVGProps {
  svg: string;
  deviceWidth: DeviceWidth['deviceWidth'];
  onClick?: MouseEventHandler<HTMLDivElement>;
  containerStyle?: React.CSSProperties;
  imageStyle?: React.CSSProperties;
  alt?: string;
  ariaHidden?: boolean;
}

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'deviceWidth',
})<DeviceWidth>(({ theme, deviceWidth }) => {
  // Calculate the maximum width from all device widths preserving the unit
  const widths = [deviceWidth?.mobile, deviceWidth?.tablet, deviceWidth?.desktop].filter(Boolean);
  const maxWidth = widths.reduce((max, current) => {
    const maxNum = parseFloat(max || '0');
    const currentNum = parseFloat(current || '0');
    return currentNum > maxNum ? current : max;
  }, widths[0] || '100%');

  return {
    maxWidth,
    [theme.breakpoints.down('sm')]: {
      width: deviceWidth?.mobile || '55%',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: deviceWidth?.tablet || '95%',
    },
    [theme.breakpoints.up('md')]: {
      width: deviceWidth?.desktop || '100%',
    },
  };
});

const StyledImage = styled('img')(() => ({
  objectFit: 'contain',
  height: 'auto',
  width: '100%',
}));

export const ResponsiveSVG = ({
  svg,
  deviceWidth,
  onClick,
  containerStyle,
  imageStyle,
  alt = 'Image',
  ariaHidden = false,
}: ResponsiveSVGProps) => (
  <StyledBox sx={containerStyle} deviceWidth={deviceWidth} onClick={onClick}>
    <StyledImage src={svg} alt={ariaHidden ? '' : alt} aria-hidden={ariaHidden} sx={imageStyle} />
  </StyledBox>
);
